import React from "react";
import SoarCard from "./SoarCard";
import FieldDisplay from "../common/FieldDisplay";
import {
  getFieldName,
  getFieldDate,
  getFieldFormattedValue,
  getFieldText,
} from "../../scripts/helperScripts";

const DiagnosisCard = ({ title, path, showEdit, dx }) => {
  return (
    <SoarCard
      cardBodyBg={
        dx.ccx_expdate !== undefined || dx["dx.ccx_expdate"] !== undefined
          ? "bg-warning"
          : "card-body-safy"
      }
      title={dx["dx.ccx_code"] + " - " + getFieldName(dx.ccx_clientdiagnosis)}
      showEdit={() => showEdit(dx)}
      path={`/main.aspx?etc=10049&extraqs=formid%3d95686683-7530-4abd-9a5b-4e4253e41a93&id=${dx.ccx_clientdiagnosisdetailid}&pagetype=entityrecord`}
      body={
        <>
          <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-2">
            <div className="col">
              <FieldDisplay
                label="Set:"
                value={getFieldName(dx["dx.ccx_diagnosistype"])}
              />
              <FieldDisplay
                label="Rank:"
                value={getFieldFormattedValue(dx.ccx_rank)}
              />
              {dx.ccx_diagnosistype && (
                <FieldDisplay
                  label="Type:"
                  value={getFieldName(dx.ccx_diagnosistype)}
                />
              )}
              {dx["dx.ccx_diagnosingprovider"] && (
                <FieldDisplay
                  label="Diagnosing Provider:"
                  value={getFieldName(dx["dx.ccx_diagnosingprovider"])}
                />
              )}
              {dx["dx.ccx_reportedby"] && (
                <FieldDisplay
                  label="Reported By:"
                  value={getFieldName(dx["dx.ccx_reportedby"])}
                />
              )}
            </div>
            <div className="col">
              {dx.ccx_reasonforaction && (
                <FieldDisplay
                  label="Reason for Action:"
                  value={getFieldName(dx.ccx_reasonforaction)}
                />
              )}
              <FieldDisplay
                label="Present on Admission:"
                value={getFieldName(dx.ccx_presentonadmissionos)}
              />
              <FieldDisplay
                label="Effective Date:"
                value={getFieldDate(dx.ccx_effdate)}
              />
              {dx.ccx_expdate && (
                <FieldDisplay
                  label="Expiration Date:"
                  value={getFieldDate(dx.ccx_expdate)}
                />
              )}
            </div>
          </div>
        </>
      }
    />
  );
};

export default DiagnosisCard;
